import classNames from "classnames";

const DocumentationPerspective = {
  Administrator: "administrator",
  ClientAdministrator: "clientadministrator",
};

function DocumentationPerspectiveSelector({
  documentationPerspective,
  setDocumentationPerspective,
}) {
  return (
    <div className="card mb-4">
      <div className="card-body">
        <h2 className="h5 fw-bold text-dark mb-2">
          Documentation perspective
        </h2>
        <p className="text-muted mb-3">
          Administrators can switch view to confirm what client
          administrators can see.
        </p>
        <div className="btn-group" role="group" aria-label="View as">
          <button
            className={classNames("btn", {
              "btn-primary":
                documentationPerspective ===
                DocumentationPerspective.ClientAdministrator,
              "btn-outline-primary":
                documentationPerspective !==
                DocumentationPerspective.ClientAdministrator,
            })}
            onClick={() =>
              setDocumentationPerspective(
                DocumentationPerspective.ClientAdministrator
              )
            }
            type="button"
          >
            Client view
          </button>
          <button
            className={classNames("btn", {
              "btn-primary":
                documentationPerspective ===
                DocumentationPerspective.Administrator,
              "btn-outline-primary":
                documentationPerspective !==
                DocumentationPerspective.Administrator,
            })}
            onClick={() =>
              setDocumentationPerspective(
                DocumentationPerspective.Administrator
              )
            }
            type="button"
          >
            Administrator view
          </button>
        </div>
      </div>
    </div>
  );
}

export { DocumentationPerspective };
export default DocumentationPerspectiveSelector;
